import { render, staticRenderFns } from "./singUp.vue?vue&type=template&id=096bfb11&"
import script from "./singUp.vue?vue&type=script&lang=js&"
export * from "./singUp.vue?vue&type=script&lang=js&"
import style0 from "./singUp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports